import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientTxnCatTransactionListPageUI from './ClientTxnCatTransactionListPageUI.js'

class ClientTxnCatTransactionListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      account: null,
      transactionList: null,
      // pagination
      lastKey: null,
      hasMore: true,
      gettingMore: false,
    }
  }

  render() {
    return (
      <ClientTxnCatTransactionListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        transactionList={this.state.transactionList}
        financialYear={this.props.match.params.financialYear}
        category={this.props.match.params.category}
        hasMore={this.state.hasMore}
        gettingMore={this.state.gettingMore}
        onMoreTransactions={this.onMoreTransactions}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    let financialYear = this.props.match.params.financialYear
    this.getClientTxnCatTxns(context, financialYear)
    this.getAccounts(context)
  }

  getClientTxnCatTxns(context, financialYear) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/` +
        `clientTxnCats/${this.props.match.params.category}/transactions`,
      cacheKey: CacheKeys.ClientTxnCatTxns(this.props.match.params.accountId, this.props.match.params.category, financialYear),
      callback: this.getClientTxnCatTxnsCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context, null, {
      financialYear: financialYear,
      limit: 100
    })
  }

  getClientTxnCatTxnsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      transactionList: response.transactionList,
      lastKey: response.lastKey,
      hasMore: response.hasMore,
    })
  }

  onMoreTransactions = () => {
    let context = this.props.context
    let financialYear = this.props.match.params.financialYear
    this.setState({gettingMore: true})

    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/` +
        `clientTxnCats/${this.props.match.params.category}/transactions`,
      cacheKey: CacheKeys.ClientTxnCatTxns(this.props.match.params.accountId, this.props.match.params.category, financialYear),
      callback: this.onMoreTransactionsCallback,
      ttlInSecs: 0
    })

    let limit = 1000
    if (this.state.transactionList.length === 100)
      limit = 900
    cacheManager.getObject2(context, null,
      {
        financialYear: financialYear,
        limit: limit,
        evaluatedKey: this.state.lastKey
      }
    )
  }

  onMoreTransactionsCallback = (response) => {
    let context = this.props.context
    let transactionList = this.state.transactionList
    transactionList = transactionList.concat(response.transactionList)

    this.setState({
      errorList: response.errorList,
      transactionList: transactionList,
      currentPage: response.currentPage,
      lastKey: response.lastKey,
      hasMore: response.hasMore,
      gettingMore: false
    })
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({account : response.account})
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    let financialYear = this.props.match.params.financialYear
    CacheManager.removeObject(CacheKeys.ClientTxnCatTxns(this.props.match.params.accountId, this.props.match.params.category, financialYear))
    if (noBusy === 'noBusy') {
      this.getClientTxnCatTxns(context, financialYear)
    }
    else {
      this.setState({
        transactionList: null,
        errorList: null,
      }, () => {
        this.getClientTxnCatTxns(context, financialYear)
      })
    }
  }
}

export default withRouter(ClientTxnCatTransactionListPageSF)
